import api from './serviceApi'; // Import the axios instance

const cityApi = {
    /**
     * Fetch all cities with optional filters.
     * @param {Object} params - Query parameters such as `include`.
     * @returns {Promise<Object>} - The list of cities.
     */
    getAllCities: async (params = {}) => {
        try {
            const response = await api.get('/city', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching all cities:', error);
            throw error;
        }
    },

    /**
     * Fetch a city by its code.
     * @param {string} code - The code of the city.
     * @param {Object} params - Query parameters such as `id` and `include`.
     * @returns {Promise<Object>} - The city data.
     */
    getCityByCode: async (code, params = {}) => {
        try {
            const response = await api.get(`/city/${code}`, { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching city by code:', error);
            throw error;
        }
    },

    /**
     * Create a new city.
     * @param {Object} cityData - The city data to create.
     * @returns {Promise<Object>} - The created city data.
     */
    createCity: async (cityData) => {
        try {
            const response = await api.post('/city', cityData);
            return response.data;
        } catch (error) {
            console.error('Error creating city:', error);
            throw error;
        }
    },

    /**
     * Update an existing city.
     * @param {Object} cityData - The city data to update.
     * @returns {Promise<Object>} - The updated city data.
     */
    updateCity: async (cityData) => {
        try {
            const response = await api.put('/city', cityData);
            return response.data;
        } catch (error) {
            console.error('Error updating city:', error);
            throw error;
        }
    },

    /**
     * Delete a city.
     * @param {Object} cityData - The city data to delete.
     * @returns {Promise<Object>} - The result of the deletion.
     */
    deleteCity: async (cityData) => {
        try {
            const response = await api.delete('/city', {
                data: cityData,
            });
            return response.data;
        } catch (error) {
            console.error('Error deleting city:', error);
            throw error;
        }
    },

    /**
     * Export cities based on filters.
     * @param {Object} params - Query parameters such as `quantityMax`, `isActive`, `term`, `orderBy`, `include`.
     * @returns {Promise<Blob>} - The exported file data.
     */
    exportCities: async (params) => {
        try {
            const response = await api.get('/city/export', {
                params
            });
            return response.data;
        } catch (error) {
            console.error('Error exporting cities:', error);
            throw error;
        }
    },

    /**
     * Fetch a paginated list of cities with optional filters.
     * @param {Object} params - Query parameters such as `page`, `quantity`, `isActive`, `term`, `orderBy`, `include`.
     * @returns {Promise<Object>} - The paginated list of cities.
     */
    getCitiesPaginated: async (params) => {
        try {
            const response = await api.get('/city/pagged', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching paginated cities:', error);
            throw error;
        }
    },
};

export default cityApi;
